module.exports = __webpack_public_path__ + "static/img/image_not_available.2cc9428e.png";